import SetAccountCurrencyModal from './set-currency-modal.jsx';

export default SetAccountCurrencyModal;
